import { render, staticRenderFns } from "./CreateCriterionModalForm.vue?vue&type=template&id=7761256f&scoped=true&"
import script from "./CreateCriterionModalForm.vue?vue&type=script&lang=ts&"
export * from "./CreateCriterionModalForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateCriterionModalForm.vue?vue&type=style&index=0&id=7761256f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7761256f",
  null
  
)

export default component.exports